export default __webpack_public_path__ + "6d7655f9b3d956ddc6b45e1592c26328.svg";